<template>
  <span class="och-embedded-html" v-html="html"></span>
</template>

<script>
export default {
  name: "embeddedHtml",
  computed: {
    html() {
      return this.linkImages(this.value);
    },
  },
  methods: {
    linkImages(text) {
      if (!text) {
        return;
      }
      return text.replace(
        /(<img\s+(?:class="[^"]+"\s*|style="[^"]+"\s*)*\s*src="(.+)"\s*(?:class="[^"]+"\s*|style="[^"]+"\s*)*\s*\/?>)/gi,
        '<a href="$2" target="_new">$1</a>'
      );
    },
  },
  props: ["value"],
};
</script>
